<span *ngIf="params?.edit">{{params.value | number}}</span>
<div class="receive" *ngIf="!params?.edit" [ngClass]="{'receive--recieved': !outstanding}">
    <input [readonly]="headerService.useBinLocation" type="number" [formControl]="control" min="0" class="receive_input" (blur)="valueChange($event)" >
    <div class="receive_button" (click)="addQty(params.data.qty)">
        {{buttonText}}
    </div>
    <i class="fal fa-box-open ms-auto"  [ngClass]="{ 'disabled': headerService.useBinLocation }"*ngIf="params.isedit && params.status==='Receiving'" (click)= "openDialog()"></i>
</div>
